import { render, staticRenderFns } from "./pos-extra-buttons-pages.vue?vue&type=template&id=01cf144a&"
import script from "./pos-extra-buttons-pages.vue?vue&type=script&lang=js&"
export * from "./pos-extra-buttons-pages.vue?vue&type=script&lang=js&"
import style0 from "./pos-extra-buttons-pages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports